import React, { FC, useState, lazy, Suspense } from 'react';
import { Box, Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ChangeOrder, ContentFilter } from '@wix/wix-ui-icons-common';
import s from './MobileActions.module.scss';
import MobileFilterModal from '../TemplateMobileFilters';
import { useTemplateGalleryFilters } from '@components/Hooks/useTemplateGalleryFilters/useTemplateGalleryFilters';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import TemplateSearchField from '../TemplateSearchField';

const MobileSortModalLayout = lazy(() =>
  import('../MobileSortModalLayout').then((module) => ({
    default: module.default,
  })),
);

const MobileActions: FC = () => {
  const { t } = useTranslation();
  const [openSortMenu, setOpenSortMenu] = useState<boolean>(false);
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const { totalFilterCount } = useTemplateGalleryFilters();
  const { logBiClick } = useTemplatesBi({ is_mobile: true });

  const hasSearchBar = false;

  const searchContainerClass = isSearchFocused ? s.searchExpand : '';
  const componentMinimizeClass = isSearchFocused
    ? s.searchExpandOtherActions
    : '';

  return (
    <>
      <Box
        className={s.sticky}
        direction="horizontal"
        align="center"
        verticalAlign="middle"
        padding="SP2 SP4"
        gap="SP2"
        backgroundColor="white"
        borderBottom="1px solid var(--wsr-color-D60, #DFE5EB)"
      >
        {hasSearchBar && (
          <Box className={searchContainerClass}>
            <TemplateSearchField
              expandable
              onFocus={() => setIsSearchFocused(true)}
              onBlur={() => setIsSearchFocused(false)}
            />
          </Box>
        )}
        <Button
          priority="secondary"
          size="medium"
          fullWidth={true}
          onClick={() => {
            logBiClick({ click_type: 'Filter' });
            setIsFilterMenuOpen((current) => !current);
          }}
          className={componentMinimizeClass}
          prefixIcon={<ContentFilter />}
        >
          {t('marketplace.templates-page.mobile.filter-cta', {
            count: totalFilterCount,
          })}
        </Button>
        <Button
          priority="secondary"
          size="medium"
          fullWidth={true}
          className={componentMinimizeClass}
          prefixIcon={<ChangeOrder />}
          onClick={() => {
            logBiClick({ click_type: 'Sort' });
            setOpenSortMenu(true);
          }}
        >
          {t('mobile-sort-button-cta')}
        </Button>
      </Box>
      {openSortMenu && (
        <Suspense fallback="">
          <MobileSortModalLayout setOpenSortMenu={setOpenSortMenu} />
        </Suspense>
      )}
      {isFilterMenuOpen && (
        <MobileFilterModal
          isOpen={isFilterMenuOpen}
          setIsFilterMenuOpen={setIsFilterMenuOpen}
        />
      )}
    </>
  );
};

export default MobileActions;
